import { createSlice, PayloadAction  } from '@reduxjs/toolkit';

// Define your slice here
interface Global {
    sitelogo: string;
    footerContent: string;
    copyright: string;
    adminEmail: string;
    contactaddress: string;
    contactemail: string;
    contactphone: string;
    footerlogo: string;
    instagramUrl: string;
    linkedinUrl: string;
    twitterUrl: string;
}

export type GlobalState = {
    Global: Global;
    loading: boolean;
    error: string | null;
};

const initialState: GlobalState = {
    Global: {
        sitelogo: '',
        footerContent: '',
        copyright: '',
        adminEmail: '',
        contactaddress: '',
        contactemail: '',
        contactphone: '',
        footerlogo: '',
        instagramUrl: '',
        linkedinUrl: '',
        twitterUrl: '',
    },
    loading: false,
    error: null
};

const globalDataSlice = createSlice({
    name: 'globalData',
    initialState,
    reducers: {
        setGlobal: (state, action: PayloadAction<Partial<Global>>) => {
            state.Global = {
                ...state.Global,
                ...action.payload,
            };
        },
    },
    extraReducers: () => {
    }
       
});

export const { setGlobal } = globalDataSlice.actions;

export default globalDataSlice.reducer;
